import { kebabCase, reduce } from 'lodash';

export interface IBettingPinnedStreamPosition {
    pPinnedStreamTop: string | null;
    pPinnedStreamRight: string | null;
    pPinnedStreamBottom: string | null;
    pPinnedStreamLeft: string | null;
}

export const DEFAULT_PINNED_STREAM_POSITION: IBettingPinnedStreamPosition = {
    pPinnedStreamTop: null,
    pPinnedStreamRight: null,
    pPinnedStreamBottom: '10px',
    pPinnedStreamLeft: '10px',
};

const REGEX_POSITION_PROPERTY = /^((\d+(\.\d+)?)(px|em|rem|vw|vh|%))|null$/i;

export const [DEFAULT_POSITION_PROPS] = convertObjectToCssVariables(
    DEFAULT_PINNED_STREAM_POSITION
);

export function convertObjectToCssVariables(
    positionProps: Partial<IBettingPinnedStreamPosition>
): [CssVariables, boolean] {
    let isAnyVariableInvalid = false;

    const convertedVariables = reduce(
        positionProps,
        (cssVariables: CssVariables, value, prop) => {
            const validationError = isValidPositionProperty(prop, value);

            if (validationError) {
                console.error(validationError);
                isAnyVariableInvalid = true;
            } else {
                cssVariables[`--${kebabCase(prop)}`] = `${value}`;
            }

            return cssVariables;
        },
        {}
    );

    return [convertedVariables, isAnyVariableInvalid];
}

function isValidPositionProperty(key: string, value: any): Error | undefined {
    if (value === null) return;

    if (typeof value !== 'string') {
        return new Error(`Allowed types for key: ${key}, are String or Null.`);
    }

    if (!(key in DEFAULT_PINNED_STREAM_POSITION)) {
        return new Error(`Not supported positioning key: ${key}`);
    }

    if (!value.match(REGEX_POSITION_PROPERTY)) {
        return new Error(
            `Not supported value of positioning key. Key: ${key}. Value: ${value}`
        );
    }
}
